import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ACCOUNT, MODAL } from '../../reduxs'
import { StyleResetPassword } from './style'
import { COLOR, IMG } from '../../themes'
import { ButtonLogin, Validate, ModalStatus } from '../../components'
import { ROUTE, RESET_PASSWORD, SET_PASSWORD, MODAL_RESETPASSWORD } from '../../helpers'

export class ResetPassword extends Component {
  constructor(props) {
    super(props)

    const { location } = props
    let path = location.pathname.toString().split('/')
    const token = path[2]

    this.state = {
      newPassword: '',
      confirmPassword: '',
      errorNewPassword: '',
      errorConfirmPassword: '',
      errorNotMatch: '',
      errorCondition: '',
      confirmStatus: false,
      token,
      showNewPassword: false,
      showConfirmPassword: false,
    }
  }

  componentDidMount() {
    const { accountAction } = this.props
    const { token } = this.state
    accountAction.verifyEmailUser({ token })
  }

  checkInput = () => {
    const { newPassword, confirmPassword } = this.state
    const { accountReducer: { language } } = this.props

    this.setState({
      errorNewPassword: '',
      errorConfirmPassword: '',
      errorNotMatch: '',
      errorCondition: ''
    })

    if (newPassword === '') {
      this.setState({
        errorNewPassword: RESET_PASSWORD.INCORRECT_NEW_PASSWORD[language]
      })
      return
    }
    if (confirmPassword === '') {
      this.setState({
        errorConfirmPassword: RESET_PASSWORD.INCORRECT_CONFIRM_PASSWORD[language]
      })
      return
    }

    const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[*@#$_!])[A-Za-z0-9*@#$_!]{6,16}$/
    if (!passwordRegex.test(newPassword)) {
      this.setState({
        errorCondition: RESET_PASSWORD.INCORRECT_CONDITION_PASSWORD[language],
        confirmPassword: '',
        errorConfirmPassword: '' 
      })
      return
    }

    if (newPassword !== confirmPassword) {
      this.setState({
        errorNotMatch: RESET_PASSWORD.PASSWORD_MISMATCH[language]
      })
      return
    }

    const { accountAction } = this.props
    accountAction.setPasswordUser({
      token: this.state.token,
      password: newPassword,
      confirmPassword,
    }, () => {
      this.setState({ confirmStatus: true })
    })
  }

  handleTextValidateNewPassword = () => {
    const {
      errorNewPassword,
      errorCondition,
    } = this.state

    if (errorNewPassword !== '') {
      return errorNewPassword
    }

    if (errorCondition !== '') {
      return errorCondition
    }

    return ''
  }

  handleTextValidateConfirmPassword = () => {
    const {
      errorConfirmPassword,
      errorNotMatch,
    } = this.state

    if (errorConfirmPassword !== '') {
      return errorConfirmPassword
    }

    if (errorNotMatch !== '') {
      return errorNotMatch
    }

    return ''
  }

  onChangeInput = {
    newPassword: event => {
      const value = event.target.value
      if (!value.includes(' ')) {
        this.setState({
          newPassword: value,
          errorNewPassword: '',
          errorNotMatch: '',
          errorCondition: '',
        }, () => {
          const { modalAction } = this.props
          modalAction.clearValidate()
        })
      }
    },
    confirmPassword: event => {
      const value = event.target.value
      if (!value.includes(' ')) {
        this.setState({
          confirmPassword: value,
          errorConfirmPassword: '',
          errorNotMatch: '',
          errorCondition: '',
        }, () => {
          const { modalAction } = this.props
          modalAction.clearValidate()
        })
      }
    }
  }

  togglePassword = (field) => {
    this.setState(prevState => ({
      [field]: !prevState[field]
    }))
  }

  goToLogin = () => {
    this.props.history.push(ROUTE.LOGIN.LINK)
  }

  render() {
    const {
      newPassword,
      confirmPassword,
      errorNewPassword,
      errorConfirmPassword,
      errorCondition,
      errorNotMatch,
      confirmStatus,
      showNewPassword,
      showConfirmPassword,
    } = this.state

    const {
      modalReducer,
      accountReducer,
      isSetPasswordPage,
      settingReducer,
    } = this.props

    const { language } = accountReducer
    const { colorTheme } = settingReducer.settingTheme
    const dynamicLang = isSetPasswordPage ? SET_PASSWORD : RESET_PASSWORD

    return (
      <StyleResetPassword confirmStatus={confirmStatus}>
        {modalReducer.status && (
          <ModalStatus
            language={language}
            code={modalReducer.status.code}
            text={modalReducer.status.description}
            status={modalReducer.status.status}
            onClick={() => {
              const { modalAction } = this.props
              modalAction.closeModalStatus()
            }}
            colorTheme={colorTheme}
          />
        )}

        {modalReducer.validate?.messageKey === 'emailTokenNotFound' && (
          <ModalStatus
            language={language}
            code={modalReducer.validate.code}
            text={modalReducer.validate.description}
            messageKey={modalReducer.validate.messageKey}
            onClick={this.goToLogin}
            colorTheme={colorTheme}
          />
        )}

        <div className='top-bar'>
          <img alt='logo' src={IMG['vich_logo_black.png']} width='77' />
        </div>

        <div className='container'>
          <div className='title'>
            {confirmStatus
              ? dynamicLang.TITLE_COMPLETE[language]
              : dynamicLang.TITLE[language]
            }
            {isSetPasswordPage && !confirmStatus && (
              <img alt='logo' src={IMG['logo_medium_size.svg']} />
            )}
          </div>

          <div
            className='sub_title'
            style={
              !confirmStatus
                ? { marginLeft: '10px', marginRight: '10px', marginBottom: 0 }
                : { marginLeft: '90px', marginRight: '90px', marginBottom: '80px' }
            }
          >
            {confirmStatus
              ? dynamicLang.SUBTITLE_COMPLETE[language]
              : dynamicLang.SUBTITLE[language]
            }
          </div>

          {!confirmStatus && (
            <div>
              <div className='data password'>
                <div><span>{dynamicLang.PASSWORD[language]}</span></div>
                <div className='input-box'>
                  <input
                    type={showNewPassword ? 'text' : 'password'}
                    style={{ border: `1px solid ${errorNewPassword || errorCondition ? COLOR['RED_2'] : COLOR['GOLD_1']}` }}
                    value={newPassword}
                    onChange={this.onChangeInput.newPassword}
                  />
                  <div onClick={() => this.togglePassword('showNewPassword')} className='icon-position'>
                    <img
                      width='24px'
                      height='24px'
                      src={IMG[showNewPassword ? 'eye.svg' : 'eyeClose.svg']}
                      alt='logo'
                    />
                  </div>
                </div>
              </div>

              <Validate
                className='validate'
                text={this.handleTextValidateNewPassword()}
              />

              <div className='data'>
                <div><span>{dynamicLang.CONFIRM_PASSWORD[language]}</span></div>
                <div className='input-box'>
                  <input
                    type={showConfirmPassword ? 'text' : 'password'}
                    style={{ border: `1px solid ${errorConfirmPassword || errorNotMatch ? COLOR['RED_2'] : COLOR['GOLD_1']}` }}
                    value={confirmPassword}
                    onChange={this.onChangeInput.confirmPassword}
                  />
                  <div onClick={() => this.togglePassword('showConfirmPassword')} className='icon-position'>
                    <img
                      width='24px'
                      height='24px'
                      src={IMG[showConfirmPassword ? 'eye.svg' : 'eyeClose.svg']}
                      alt='logo'
                    />
                  </div>
                </div>
              </div>

              <Validate
                className='validate'
                text={this.handleTextValidateConfirmPassword()}
              />

              <div className='validate no-errors'>
                <p>{RESET_PASSWORD.PASSWORD_CONDITION_TITLE[language]}</p>
                <ul>
                  <li>{RESET_PASSWORD.RANGE_PASSWORD[language]}</li>
                  <li>{RESET_PASSWORD.UPPER_CASE_PASSWORD[language]}</li>
                  <li>{RESET_PASSWORD.LOWER_CASE_PASSWORD[language]}</li>
                  <li>{RESET_PASSWORD.NUMBER_PASSWORD[language]}</li>
                  <li>{RESET_PASSWORD.SPECIAL_CHARACTER_PASSWORD[language]}</li>
                </ul>
              </div>
            </div>
          )}

          {confirmStatus ? (
            <div className='btn_done'>
              <ButtonLogin
                name={MODAL_RESETPASSWORD.DONE[language]}
                onClick={() => window.location.assign(`${ROUTE.BOOKING.LINK}${ROUTE.LOGIN.LINK}`)}
              />
            </div>
          ) : (
            <div className='btn_save'>
              <ButtonLogin
                name={RESET_PASSWORD.SAVE_PASSWORD[language]}
                onClick={this.checkInput}
              />
            </div>
          )}
        </div>

        <div className='footer'>
          <span>Copyright © 2019 Vichai Trading (1983) Co. Ltd., All Right Reserved.</span>
        </div>
      </StyleResetPassword>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  accountAction: bindActionCreators(ACCOUNT.action, dispatch),
  modalAction: bindActionCreators(MODAL.action, dispatch)
})

const mapStateToProps = ({
  accountReducer,
  modalReducer,
  loaderReducer,
  settingReducer,
}) => ({
  modalReducer,
  accountReducer,
  loaderReducer,
  settingReducer,
})

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword)